import {
    MENU_EXPAND,
    MENU_EXPAND_SUCCESS,
    MENU_EXPAND_ERROR,
    MENU_COLLAPSE,
    MENU_COLLAPSE_SUCCESS,
    MENU_COLLAPSE_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    expandMenu: false,
    error: null,
    loading: false
}

export default function(state = initialState, action) {
    switch(action.type){
        case MENU_EXPAND:
        case MENU_COLLAPSE:
            return {
                ...state,
                loading: true
            }
        case MENU_COLLAPSE_ERROR:
        case MENU_EXPAND_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case MENU_COLLAPSE_SUCCESS:
        case MENU_EXPAND_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                expandMenu: action.payload
            }
        default:
            return state;
    }
}